module.exports = __webpack_public_path__ + "static/media/Mail.c3735e32.svg";